import {getAdmissions} from "../../api/addmissions";

const Layout = dynamic(() => import('../../hoc/staticLayout'), { loading: () => <></>, ssr: true });
import AdmissionContent from "../../components/static/admissionsPage/admissions";
import { withRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { getAllPrograms, getAllHeardSources } from '../../api/register';

function Information(props) {
	const meta = {
		title: "Graduate School Information | Bayan",
		description: "The Master of Arts (Religious Studies) in Islamic Studies is a two-year graduate program that focuses on the study of religious traditions, theology and ethics. Culminating with a Master’s Thesis, this program allows you to concentrate your studies in an area of interest. This is an appropriate degree if you are preparing for further study at the doctoral level; seeking advanced theological study as a foundation for service; or simply wish to study theology and religion without the aim of entering professional ministry.",
		route: "information",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<AdmissionContent router={props.router} programs={props.programs} sources={props.sources} addmissionsData={props?.addmissionsData}/>
			</Layout>
		</>
	);
}
// export async function getStaticProps() {
export async function getServerSideProps(ctx) {
	// You can use any data fetching library
	const programs = await getAllPrograms();
	const heardSources = await getAllHeardSources();
	const addmissionsData = await getAdmissions();
	return {
		props: {
			programs: programs || null,
			sources: heardSources || null,
			addmissionsData: addmissionsData || null,
		},
		// revalidate: 5*60, // seconds
	}
}


export default withRouter(Information);
